export default "__VITE_ASSET__bN8wI4FJ__"